import React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createReactEditorJS } from "react-editor-js";
import { EDITOR_JS_TOOLS } from "../helper/constants";
import TextField from "@material-ui/core/TextField";

import { addAboutUs, updateAboutUs } from "../store/aboutUs";

export default function FormEditor({
  buttonText,
  brokerageCode,
  aboutUsList,
  aboutUsIndex,
  settoggleNewUserModel,
  setToggleUpdateUserModel,
}) {
  const ReactEditorJS = createReactEditorJS();
  const [aboutUs, setAboutUs] = useState("");
  const [title, setTitle] = useState("");
  const aboutUsRef = useRef();
  const dispatch = useDispatch();

  const handleInitialize = useCallback((instance) => {
    aboutUsRef.current = instance;
    if (buttonText === "Update") {
      setTitle(aboutUsList[aboutUsIndex].title);
      setAboutUs({
        blocks: aboutUsList[aboutUsIndex].body,
      });
    }
  }, []);

  const handleChange = useCallback(async () => {
    const savedData = await aboutUsRef.current?.save();
    setAboutUs(savedData);
  }, []);

  const handleClick = () => {
    if (title && aboutUs != "") {
      let data = [...aboutUsList];
      const payload = {
        title: title,
        body: aboutUs?.blocks,
      };
      if (buttonText === "Update") {
        data[aboutUsIndex] = payload;
        setToggleUpdateUserModel(false);
        dispatch(
          updateAboutUs({
            code: brokerageCode,
            aboutUs: payload,
            id: aboutUsList[aboutUsIndex]._id,
          })
        );
      } else {
        data.push(payload);
        settoggleNewUserModel(false);
        dispatch(addAboutUs({ code: brokerageCode, aboutUs: payload }));
      }
    } else {
      alert("Fill all fields!");
    }
  };
  return (
    <div>
      <form noValidate className="form-group">
        <div className="row">
          <label className="col-sm-3 col-form-label">Title </label>
          <div className="col-sm-9">
            <TextField
              style={{ width: "100%" }}
              fullWidth
              variant="outlined"
              margin="normal"
              required
              label="Enter the title name"
              defaultValue={
                buttonText === "Update" ? aboutUsList[aboutUsIndex].title : null
              }
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="row mt-2">
          <label className="col-sm-3 col-form-label">Body</label>
          <div className="col-sm-9">
            <ReactEditorJS
              style={{ backgroundColor: "#d6dae6" }}
              onInitialize={handleInitialize}
              instanceRef={(instance) => (aboutUsRef.current = instance)}
              tools={EDITOR_JS_TOOLS}
              placeholder="Enter Body"
              onChange={handleChange}
              defaultValue={
                buttonText === "Update"
                  ? {
                      blocks: aboutUsList[aboutUsIndex].body,
                    }
                  : null
              }
            ></ReactEditorJS>
          </div>
        </div>

        <div className="row mt-2 d-flex justify-content-center">
          <div className="col-6">
            <button
              type="button"
              style={{
                backgroundColor: "#4cabd4",
                borderRadius: "20px",
              }}
              className="btn btn-primary btn-block"
              onClick={handleClick}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
